import { useState, useEffect } from 'react';
import { message } from 'antd';
import {
  adminService,
  AdminStats as AdminStatsType,
} from '../../api/services/adminService';

export const useAdminStats = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState<AdminStatsType>({
    totalListings: 0,
    activeListings: 0,
    rejectedListings: 0,
    totalRevenue: 0,
    todaySubmissions: 0,
    recentActivity: [],
  });
  const fetchStats = async () => {
    setLoading(true);
    try {
      const data = await adminService.getDashboardStats();

      setStats({
        totalListings: data.totalListings || 0,
        activeListings: data.activeListings || 0,
        rejectedListings: data.rejectedListings || 0,
        totalRevenue: data.totalRevenue || 0,
        todaySubmissions: data.todaySubmissions || 0,
        recentActivity: data.recentActivity || [],
      });
    } catch (error) {
      message.error('Failed to load admin statistics');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return {
    loading,
    stats,
    refetch: fetchStats,
  };
};
